<template>
<div class="animated fadeIn">
  <b-card>
    <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
      <b-row>
        <b-col sm="4" v-if="this.showPeriodOption">
          <b-form-group label="Period" label-for="period" :state="chkState('period')">
            <v-select ref="period" id="period" name="period" :options="periodsList"  v-model="$v.form.period.$model" ></v-select>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="From" :state="chkState('fromDate')">
            <v-date-picker  :formats='dateformats' v-model="$v.form.fromDate.$model" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="To" :state="chkState('toDate')">
            <v-date-picker :formats='dateformats' v-model="$v.form.toDate.$model" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-btn type="submit" variant="success" :disabled="$v.form.$invalid || this.form.fromDate > this.form.toDate">Submit</b-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</div>
</template>

<script>
import Vue from 'vue'
import { validationMixin } from "vuelidate";
import {
  required, requiredIf
} from "vuelidate/lib/validators"
const formShape = {
  period: null,
  fromDate: new Date(),
  toDate: new Date()
}


export default {
  name: 'ReportSearchOptions',
  mixins: [validationMixin],
  props: {
    periodOption: {
      type: Boolean,
      default: false,
    }

  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    }
  },
  data: function() {
    return {
      submitted: false,
      from: '',
      to: '',
      form: Object.assign({}, formShape),
      periodsList: ['Daily', 'Weekly', 'Monthly', 'Yearly'],
      showPeriodOption: this.periodOption,
    }
  },
  validations: {
    form: {
      period: {
        required: requiredIf(function(form){
          return this.showPeriodOption
        })
      },
      fromDate: {
        required
      },
      toDate: {
        required
      }
    }
  },
  methods: {

    isPeriodOptionEnabled(){
      return this.showPeriodOption;
    },
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          let params = {
            period: this.$v.form.period.$model,
            searchByPeriod: this.periodOption,
            fromDate: this.$moment(this.$v.form.fromDate.$model).format('YYYY-MM-DD'),
            toDate: this.$moment(this.$v.form.toDate.$model).format('YYYY-MM-DD')
          }
          this.$emit('search', params)
        })
      }
    },
    onReset() {
      this.form = formShape
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val) {
      const field = this.$v.form[val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  }
}
</script>
